// src/context/AuthContext.tsx


import { Loader2 } from 'lucide-react';
import { createContext, ReactNode, useContext } from 'react';
import { useAuth } from '../hooks/use-auth';


interface AuthContextType {
  user;
  loading: boolean;
  error;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
  redirectToLogin?: boolean;
}

export const AuthProvider = ({
  children,
  redirectToLogin = false,
}: AuthProviderProps) => {
  const { user, loading, error } = useAuth({ redirectToLogin });

  // Only show loading on initial load, not during token updates
  // This prevents the OTP component from being hidden during registration
  const hasToken = localStorage.getItem('token');
  const shouldShowLoading = loading && !hasToken;

  if (shouldShowLoading) {
    return <Loader2 className="h-5 w-5 animate-spin" />;
  }

  return (
    <AuthContext.Provider value={{ user, loading, error }}>
      {children}
    </AuthContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useAuthContext = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};
